import { render } from "./PostShortCardSkeleton.vue?vue&type=template&id=dd59928a&scoped=true"
import script from "./PostShortCardSkeleton.vue?vue&type=script&lang=js"
export * from "./PostShortCardSkeleton.vue?vue&type=script&lang=js"

import "./PostShortCardSkeleton.vue?vue&type=style&index=0&id=dd59928a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd59928a"]])

export default __exports__